export function Sidebar3Icon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.3 10.8057L14.1056 12L15.3 13.1944C15.7296 13.624 15.7296 14.3204 15.3 14.75C14.8704 15.1796 14.1739 15.1796 13.7443 14.75L11.7722 12.7778C11.3426 12.3483 11.3426 11.6518 11.7722 11.2222L13.7443 9.25002C14.1739 8.82044 14.8704 8.82044 15.3 9.25002C15.7296 9.67959 15.7296 10.3761 15.3 10.8057Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4 1C20.0451 1 23 3.95492 23 7.6V16.4C23 20.0451 20.0451 23 16.4 23H7.6C3.95492 23 1 20.0451 1 16.4V7.6C1 3.95492 3.95492 1 7.6 1H16.4ZM8.7 20.8V3.2H16.4C18.8301 3.2 20.8 5.16995 20.8 7.6V16.4C20.8 18.8301 18.8301 20.8 16.4 20.8H8.7ZM6.5 3.33862V20.6614C4.60225 20.1729 3.2 18.4502 3.2 16.4V7.6C3.2 5.54978 4.60225 3.82707 6.5 3.33862Z"
        fill="currentColor"
      />
    </svg>
  );
}
